<fieldset bsMigration [bs3Class]="['panel-default']" [bs4Class]="['mb-3']" formGroupName="demographics" class="panel" [disabled]="isSaving">
  <legend bsMigration class="panel-heading">Misc Information</legend>
  <div bsMigration class="panel-body">
    <p>Necessary demographic information</p>
    <div *ngIf="settings.pac_base_asn_code == 'ABMP'" [bs4Class]="['mb-2']" class="form-group" [class.has-error]="ind_mblex_date_extHasError | async">
      <label for="input-mblex">Anticipated MBLEx Date</label>
      <input type="text" [class.is-invalid]="ind_mblex_date_extHasError | async" class="form-control" id="input-mblex" placeholder="mm/dd/yyyy" formControlName="ind_mblex_date_ext">
      <p class="help-text" *ngIf="!this.individual.ind_mblex_date_ext">Students, please provide your best estimate. If you've already taken the MBLEx, or it's not required in your state, please leave this blank.</p>
      <p class="help-text" *ngIf="this.individual.ind_mblex_date_ext">Your school has given us this as your estimated MBLEx test date.</p>
    </div>
    <div [bs4Class]="['mb-2']" class="form-group" [class.has-error]="ind_dobHasError | async">
      <label for="input-dob">Date of Birth</label>
      <input type="text" [class.is-invalid]="ind_dobHasError | async" class="form-control" id="input-dob" placeholder="mm/dd/yyyy" formControlName="ind_dob" required>
    </div>
    <div class="form-group">
      <label for="input-gender">Gender</label>
      <select id="input-gender" [bs3Class]="['form-control']" [bs4Class]="['form-select']" formControlName="ind_gender" required>
        <option [ngValue]="null" disabled>- Select -</option>
        <option [ngValue]="gender.Male">Male</option>
        <option [ngValue]="gender.Female">Female</option>
        <option [ngValue]="gender.Other">Other/No Answer</option>
      </select>
    </div>
  </div>
</fieldset>
